import React, { useState } from "react";
import Indentification from "../elements/Indentification";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

const AvatarUpload = ({
  src,
  initial,
  alt,
  onChange = () => {},
  handleRemove = () => {},
}) => {
  const [isHovered, setIsHovered] = useState(false);

  function imageUploadHandler(e) {
    const file = e.target.files[0];
    const type = file?.type.split("/")[0];
    if (type === "image") {
      onChange(file);
    } else {
      toast.info("only upload image.");
    }
  }

  return (
    <label
      className="h-32 w-32 min-w-20 rounded-full overflow-hidden flex flex-col relative group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      htmlFor="avatarUpload"
    >
      <div className="h-full w-full">
        <Indentification
          image={src}
          size="max"
          initialClass="text-2xl"
          className={"border-0"}
          initial={initial}
          alt={alt}
        />
      </div>
      {src && (
        <div className="w-full h-full absolute left-0 top-0 items-center justify-center hidden group-hover:flex">
          <button
            onClick={handleRemove}
            type="button"
            className="hover:bg-primary hover:text-white rounded-md flex items-center justify-center w-9 h-9"
          >
            <i className="fa-fw fa-regular fa-trash-can"></i>
          </button>
        </div>
      )}

      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: isHovered ? "0%" : "100%" }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className="bg-black/25 absolute bottom-0 left-0 w-full h-6 flex items-center justify-center text-white"
      >
        <i className="fa-fw fa-regular fa-camera text-xs"></i>
      </motion.div>

      <input
        type="file"
        onChange={imageUploadHandler}
        className="hidden"
        id="avatarUpload"
      />
    </label>
  );
};

export default AvatarUpload;
